<section class="anc-panel-card" [class.anc-panel-card--collapsed]="collapsible() && collapsed()">
    <header
        class="anc-panel-card__header"
        [class.anc-panel-card__header--collapsible]="collapsible()"
        [attr.role]="collapsible() ? 'button' : null"
        [attr.aria-expanded]="collapsible() ? !collapsed() : null"
        [attr.tabindex]="collapsible() ? 0 : null"
        (click)="toggle($event)"
        (keydown.enter)="toggle($event)"
        (keydown.space)="$event.preventDefault(); toggle($event)"
    >
        <div class="anc-panel-card__heading">
            <!-- No `translate` ATTRIBUTE here: the directive stores the first
                 rendered text as its lookupKey and rewrites the node on every
                 ngAfterViewChecked, which permanently pins an interpolated
                 title to whatever value rendered before async data arrived
                 (OEM-6656). The `| translate` pipe below already translates. -->
            <h2 class="anc-panel-card__title">{{ title() | translate }}</h2>
            <span class="anc-panel-card__count" *ngIf="count() !== null">{{ count() }}</span>
        </div>
        <span class="anc-panel-card__caption" *ngIf="caption()">{{ caption() | translate }}</span>
        <ng-content select="[ancCardHeaderActions]"></ng-content>
        <span
            *ngIf="collapsible()"
            class="anc-panel-card__chev icon icon--24"
            [class.icon-chevron-up]="!collapsed()"
            [class.icon-chevron-down]="collapsed()"
            aria-hidden="true"
        ></span>
    </header>
    <div
        *ngIf="!collapsible() || !collapsed()"
        class="anc-panel-card__body"
        [class.anc-panel-card__body--padded]="padded()"
    >
        <ng-content></ng-content>
    </div>
</section>
